import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DEFAULT_ROUTER_FEATURENAME } from '@ngrx/router-store';

import { ModuleRouterState } from '../types/module-router.types';

const selectRawRouterState = createFeatureSelector<{ state: ModuleRouterState }>(DEFAULT_ROUTER_FEATURENAME);

const selectRouterState = createSelector(selectRawRouterState, (s) => s?.state || null);

export const selectUrl = createSelector(selectRouterState, (s) => s?.url || '');

export const selectQueryParams = createSelector(selectRouterState, (s) => s?.queryParams || {});

export const selectCompanyId = createSelector(selectRouterState, (s) => s?.companyId || null);

export const selectModule = createSelector(selectRouterState, (s) => s?.module || null);

export const selectSubmodule = createSelector(selectRouterState, (s) => s?.submodule || null);

export const selectDetailId = createSelector(selectRouterState, (s) => s?.detailId || null);

export const selectData = createSelector(selectRouterState, (s) => s?.data || null);
